import React from 'react'
import { Route, Router, Switch } from 'react-router-dom'
import { AppThemeProvider } from 'src/Styles/theme'
import Home from 'src/Home'
import Result from 'src/Result'
import { Route as RoutePath } from 'src/Common/Route'
import SpeedTestDetail from 'src/SpeedTestDetail'
import { AdditionalDetails } from 'src/Home/AdditionalDetail/MobileView/FullScreenDetails'
import { WhiteLabelContext } from 'src/white-label'
import {
  getWhiteLabelInfo,
  APP_BRANDING_KEY,
} from 'src/white-label/FindWhiteLabel'
import history from './history'
import { MessageEventHandler } from 'src/App/MessageEventHandler'
import { BackClickEventHandler } from 'src/App/BackClickEventHandler'

// eslint-disable-next-line import/no-anonymous-default-export
export default () => {
  const search = window.location.search
  const params = new URLSearchParams(search)
  const brandingValue = params.get('app_branding_key')
  let whiteLabelValue = 'pg3'
  if (!localStorage.getItem(APP_BRANDING_KEY)) {
    whiteLabelValue = brandingValue ? brandingValue : 'pg3'
    localStorage.setItem(APP_BRANDING_KEY, whiteLabelValue)
  } else {
    const storedWhiteLabelValue = localStorage.getItem(APP_BRANDING_KEY)
    whiteLabelValue = storedWhiteLabelValue ? storedWhiteLabelValue : 'pg3'
  }
  const whiteLabel = getWhiteLabelInfo(whiteLabelValue)

  MessageEventHandler()
  BackClickEventHandler()
  return (
    <Router history={history}>
      <WhiteLabelContext.Provider value={whiteLabel}>
        <AppThemeProvider theme={whiteLabel.theme}>
          <Switch>
            <Route exact={true} path={RoutePath.HOME} render={Home} />
            <Route exact={true} path={RoutePath.RESULT} render={Result} />
            <Route
              exact={true}
              path={RoutePath.SPEED_TEST_DETAIL}
              render={SpeedTestDetail}
            />
            <Route
              exact={true}
              path={RoutePath.ADDITIONAL_DETAILS}
              render={AdditionalDetails}
            />
          </Switch>
        </AppThemeProvider>
      </WhiteLabelContext.Provider>
    </Router>
  )
}
